import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    closeShipmentItemsCreatePopup,
    closeShipmentItemsEditPopup,
    selectShipmentBoxes,
    selectShipmentItemDeletingStatus,
    selectShipmentItemsCreatingStatus,
    selectShipmentItemsUpdatingStatus,
    setShipmentItemsCreatePopupData,
    setShipmentItemsEditPopupData,
    uploadShipmentBoxes,
} from "../shipmentItemsSlice";
import { selectShipment } from "../../shipmentSlice";
import ShipmentBoxItem from "./ShipmentBoxItem";
import CreateNewBoxButton from "./CreateNewBoxButton";

const ShipmentBoxes = () => {
    const dispatch = useDispatch();
    const shipmentBoxes = useSelector(selectShipmentBoxes);
    const shipment = useSelector(selectShipment);

    const shipmentItemsUpdatingStatus = useSelector(
        selectShipmentItemsUpdatingStatus
    );
    const shipmentItemsDeletingStatus = useSelector(selectShipmentItemDeletingStatus)
    const shipmentCreatingStatus = useSelector(
        selectShipmentItemsCreatingStatus
    );

    //on creating shipment item
    useEffect(() => {
        if (shipmentCreatingStatus !== "fulfilled") {
            return;
        }
        
        dispatch(
            setShipmentItemsCreatePopupData({
                data: null,
            })
        );
        dispatch(closeShipmentItemsCreatePopup());

        return () => {
            dispatch(closeShipmentItemsCreatePopup());
            dispatch(
                setShipmentItemsCreatePopupData({
                    data: null,
                })
            );
        }
    }, [dispatch, shipmentCreatingStatus]);

    // on updating shipment item
    useEffect(() => {
        if (shipmentItemsUpdatingStatus !== "fulfilled") {
            return;
        }
        dispatch(closeShipmentItemsEditPopup());
        dispatch(
            setShipmentItemsEditPopupData({
                data: {},
            })
        );

        return () => {
            dispatch(closeShipmentItemsEditPopup());
            dispatch(
                setShipmentItemsEditPopupData({
                    data: {},
                })
            );
        }
    }, [dispatch, shipmentItemsUpdatingStatus]);

    // on deleting shipment item
    useEffect(() => {
        if (shipmentItemsDeletingStatus !== "fulfilled") {
            return;
        }

        dispatch(closeShipmentItemsEditPopup());
        dispatch(
            setShipmentItemsEditPopupData({
                data: null,
            })
        )
        return () => {
            dispatch(closeShipmentItemsEditPopup());
            dispatch(
                setShipmentItemsEditPopupData({
                    data: {},
                })
            );
        }
    }, [dispatch, shipment.id, shipmentItemsDeletingStatus]);


    // on changing shipment id
    useEffect(() => {
        dispatch(uploadShipmentBoxes({ shipmentID: shipment.id }));
    }, [dispatch, shipment.id]);

    return (
        <div>
            <div className="flex flex-col gap-6 mb-8">
                {shipmentBoxes.map((box, index) => 
                    <ShipmentBoxItem box={box} key={index} index={index + 1} />
                )}
            </div>
            {
                shipment && !shipment.blocked && 
                <CreateNewBoxButton />
            }
        </div>
    );
};


export default ShipmentBoxes;
